import { Component, OnInit, Output, EventEmitter } from "@angular/core";
import { ApiService } from "../../services/api.service";
import { SharedService } from "src/app/services/shared.service";
import { ToastrService } from "ngx-toastr";
@Component({
  selector: "app-benefits-plans",
  templateUrl: "./benefits-plans.component.html",
  styleUrls: ["./benefits-plans.component.scss"]
})
export class BenefitsPlansComponent implements OnInit {
  @Output() benfitsStatus = new EventEmitter<string>();
  @Output() showLogin = new EventEmitter<string>();
  public isSubscribed = false;
  public btnText = "Subscribe";
  public responseMsg = "";
  public responseTitle = "";
  private isUserRole = "";
  constructor(
    public shared: SharedService,
    private _api: ApiService,
    private _toast: ToastrService
  ) {}

  ngOnInit() {
    console.log("this.shared.userInfo", this.shared.userInfo);
    if (this.shared.userInfo !== null) {
      this.isUserRole = this.shared.userInfo.identity.role || "";
    } else {
      this.isUserRole = "";
    }
  }

  close() {
    // console.log('closemodal')
    this.isSubscribed = false;
    this.benfitsStatus.emit("false");
  }

  /* openLogin() {
    this.showLogin.emit('2');
  } */

  //---------------------
  openLogin(regType) {
    //console.log("open login", regType, this.shared.userInfo.identity.role);
    this.showLogin.emit("2");
    console.log(this.shared.userInfo);
    if (this.shared.userInfo) {
      console.log("not Null user");
      if (this.shared.userInfo.identity.role === 3 && regType === 1) {
        this._toast.error("You are already registered user!");
      } else if (this.shared.userInfo.identity.role === 3 && regType === 2) {
        this.subscribeToPlans();
      } else if (
        this.shared.userInfo.identity.role === 2 ||
        this.shared.userInfo.identity.role === 0
      ) {
        this._toast.error("You are already subscribed user!");
      }
    } else {
      this.shared.toggleLoginRegisterModal(regType, 1);
      this.shared.goToRoute("/authentication/login", 0);
    }
  }
  //---------------------

  subscribeToPlans() {
    this.btnText = "Sending..";
    this._api.subscribePlans().subscribe(
      response => {
        console.log(response);
        if (response.repsonseType === "success") {
          this.btnText = "Subscribe";
          this.isSubscribed = true;
          this.responseTitle = "Thank you!";
          this.responseMsg =
            "Your request has been captured. Our team will get back to you.";
        }
      },
      err => {
        if (err.error) {
          this.btnText = "Subscribe";
          this.isSubscribed = true;
          this.responseTitle = "";
          this.responseMsg =
            "Oops, something went wrong! Please try again later.";
        }
      }
    );
  }
}
